
import Header from "../Components/Header"

import Footer from "../Components/Footer";
import CommonLanding from "../Components/CommonLanding";
import "swiper/css";
import "swiper/css/navigation";

export default function CorporateEventsLanding() {
  return (
    <>
    <CommonLanding
      title="Luxury Corporate Events on Yachts"
      subtitle="Impress clients with premium experiences"
      heading="Business Meets Luxury"
      text="Host meetings, launches, and networking events on luxury yachts."
      image="https://images.unsplash.com/photo-1492724441997-5dc865305da7"
      ctaText="Book Event"
      schema={{
        "@context": "https://schema.org/",
        "@type": "Service",
        "serviceType": "Corporate Yacht Events"
      }}
      features={[
        { title: "Networking Decks", desc: "Spacious layouts." },
        { title: "AV Support", desc: "Screens & sound." },
        { title: "Premium Service", desc: "Luxury hospitality." }
      ]}
    />
      <Header />

      <section className="ib-bday-wrapper">
        <div className="ib-bday-hero">
          <h1 className="ib-bday-title">
            Luxury Corporate Events on Yachts
          </h1>
          <p className="ib-bday-subtitle">
            Impress clients with premium experiences.
          </p>
        </div>

        <div className="ib-bday-section">
          <h2 className="ib-bday-heading">
            Business Meets Luxury
          </h2>
          <p className="ib-bday-text">
            Ideal for meetings, launches, and networking events.
          </p>
        </div>

        <div className="ib-bday-feature-grid">
          <div className="ib-bday-card">
            <h3>Networking Decks</h3>
            <p>Spacious layouts for events.</p>
          </div>

          <div className="ib-bday-card">
            <h3>AV Support</h3>
            <p>Presentation-ready setup.</p>
          </div>

          <div className="ib-bday-card">
            <h3>Premium Service</h3>
            <p>Top-tier hospitality.</p>
          </div>
        </div>

        <div className="ib-bday-cta">
          <a href="/contact" className="ib-bday-btn">
            Book Event
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}
